/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconObservability = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.052 14.32h.813L21 19.468 19.467 21l-5.146-5.136v-.813l-.278-.288A6.66 6.66 0 0 1 9.69 16.38a6.69 6.69 0 1 1 5.777-10.063l1.935-1.804h-.867a.738.738 0 1 1 0-1.477h3.48V6.48a.738.738 0 1 1-1.476 0V5.47l-2.445 2.28a6.69 6.69 0 0 1-1.33 6.293l.288.278Zm-9.455-2.456a4.625 4.625 0 0 0 4.093 2.457 4.625 4.625 0 0 0 4.623-4.91l-2.302 2.145a.738.738 0 0 1-.992.013L8.513 9.358l-2.916 2.506Zm-.493-1.523A4.625 4.625 0 0 1 9.69 5.058c1.877 0 3.49 1.11 4.217 2.712l-2.413 2.249-2.486-2.194a.738.738 0 0 0-.97-.006l-2.934 2.522Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconObservability.displayName = 'IconObservability';
export default IconObservability;
